var _circle, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContractRedliningSelected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_700_547",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 11,
    width: 18,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 11,
    width: 18,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_700_547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2222 25.5263H22.7778V23.7368H19.2222V25.5263ZM19.2222 21.9474H25.4444V20.1579H19.2222V21.9474ZM16.5556 18.3684H25.4444V16.5789H16.5556V18.3684ZM16.2222 30C15.0519 30 14.0556 29.5862 13.2333 28.7586C12.4111 27.9309 12 26.9281 12 25.75C12 24.9 12.2185 24.1395 12.6556 23.4684C13.0926 22.7974 13.6667 22.2904 14.3778 21.9474H12.1111V20.1579H17.4444V25.5263H15.6667V23.3566C15.1185 23.4759 14.6667 23.7592 14.3111 24.2066C13.9556 24.6539 13.7778 25.1684 13.7778 25.75C13.7778 26.436 14.0185 27.0175 14.5 27.4947C14.9815 27.9719 15.5556 28.2105 16.2222 28.2105V30ZM19.2222 29.1053V27.3158H27.2222V14.7895H14.7778V18.3684H13V14.7895C13 14.2974 13.1741 13.8761 13.5222 13.5257C13.8704 13.1752 14.2889 13 14.7778 13H27.2222C27.7111 13 28.1296 13.1752 28.4778 13.5257C28.8259 13.8761 29 14.2974 29 14.7895V27.3158C29 27.8079 28.8259 28.2292 28.4778 28.5796C28.1296 28.93 27.7111 29.1053 27.2222 29.1053H19.2222Z",
    fill: "#3474E0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractRedliningSelected);
export default __webpack_public_path__ + "static/media/contract_redlining_selected.bce6b619180b58e140c758943aa4dea2.svg";
export { ForwardRef as ReactComponent };